<template>
  <div v-bind:class="{ paddingContent: isSidebarShow, nonPaddingContent: !isSidebarShow }">
    <div class="container">
      <div class="breadCrumbsContainer" style="display: flex;" v-if="role === 'admin'">
        現場情報 - {{name}}
        <div class="headerBtn" @click="siteList" style="margin: 0px 0px 0px 20px;">
          一覧に戻る
        </div>
      </div>
      <!-- ローディング -->
      <div v-if="getLodingFlg">
        <vue-loading
          type="cylon"
          color="#1b7e47"
          :size="{ width: '150px', height: '150px' }"
        >
        </vue-loading>
        <div v-if="getLodingFlg" style="padding: 0px 0px 30px 0px;">Now loading...</div>
        <div v-if="postLodingFlg" style="padding: 0px 0px 30px 0px;">Now registering...</div>
      </div>
      <!-- 取得エラー表示 -->
      <div v-if="getErrorFlg || postErrorFlg" style="padding: 0px 0px 30px 0px; margin: auto;">
        <div　class="errMsg">
          <div class="errSpan" style="font-size:x-large;">
            {{errorMessage}}
          </div>
        </div>
      </div>
      <!-- 施工体制取得/連携状況取得エラー表示 -->
      <div v-if="syncStatusFailedMessage" style="padding: 0px 0px 30px 0px; margin: auto;">
        <div　class="errMsg">
          <div class="errSpan" style="font-size:x-large;">
            {{syncStatusFailedMessage}}
          </div>
        </div>
      </div>
      <!-- 技能者・事業者画面 -->
      <div v-if="role !== 'admin'">
        <form v-if="!getLodingFlg && !getErrorFlg">
          <div class="group" style="padding-bottom: 0px">
            <div class="row">
              <p class="inputTitle editable">CCUS現場ID</p>
              <div class="rowRight">
                <input type="text" class="text large" name="detail.ccusId"
                v-model="detail.ccusId" readonly/>
              </div>
            </div>
            <div class="row">
              <p class="inputTitle editable">現場名</p>
              <div class="rowRight">
                <input type="text" class="text large" name="detail.siteName"
                v-model="detail.siteName" readonly/>
              </div>
            </div>
            <div class="row">
              <p class="inputTitle editable">住所</p>
              <div class="rowRight">
                <input type="text" class="text large" name="detail.fullAddress"
                v-model="detail.fullAddress" readonly/>
              </div>
            </div>
            <!-- <div>
              <div id="mapid"></div>
              GoogleマップAPI使用予定
              <iframe
              src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3240.827853398542!2d139.76493611522864!3d35.68124053757879!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x60188bfbd89f700b%3A0x277c49ba34ed38!2z5p2x5Lqs6aeF!5e0!3m2!1sja!2sjp!4v1594286431753!5m2!1sja!2sjp"
              width="550" height="325" frameborder="0"style="border:0;"
              allowfullscreen="" aria-hidden="false" tabindex="0"></iframe>
            </div> -->
          </div>
        </form>
      </div>
      <!-- 運営管理者画面 -->
      <div v-if="role === 'admin'">
        <form v-if="!getLodingFlg && !getErrorFlg">
          <div class="group">
            <div class="groupTitle" style="display: flex;">
              現場情報
            </div>
            <div class="row">
              <p class="inputTitle editable">内部ID</p>
              <div class="rowRight">
                <input type="text" class="text large" name="id"
                v-model="id" readonly/>
              </div>
            </div>
            <div class="row">
              <p class="inputTitle editable">事業者</p>
              <div class="rowRight">
                <input type="text" class="text large" name="companyName"
                v-model="detail.companyName" readonly/>
              </div>
            </div>
            <div class="row">
              <p class="inputTitle editable">CCUS現場ID</p>
              <div class="rowRight">
                <input type="text" class="text large" name="ccusId"
                v-model="detail.ccusId" readonly/>
              </div>
            </div>
            <div class="row">
              <p class="inputTitle editable">現場名</p>
              <div class="rowRight">
                <input type="text" class="text large" name="siteName"
                v-model="detail.siteName" readonly/>
              </div>
            </div>
            <div class="row">
              <p class="inputTitle editable">住所</p>
              <div class="rowRight">
                <input type="text" class="text large" name="fullAddress"
                v-model="detail.fullAddress" readonly/>
              </div>
            </div>
            <!-- <div class="row">
              <p class="inputTitle editable">緯度経度</p>
              <div class="rowRight">
                <button class="edit" @click="openGoogleMap" type = "button"
                 style="min-width: 494px; border-radius:10px;">
                 i アイコン設定予定></i>
                  Googleマップを開く
                </button>
              </div>
            </div> -->
            <div class="row">
              <p class="inputTitle editable">最終更新日時</p>
              <div class="rowRight">
                <input type="text" class="text large" name="updatedAt"
                v-model="detail.updatedAt" readonly/>
              </div>
            </div>
          </div>
          <div class="group">
            <div class="groupTitle" style="display: flex;">
              施工体制
            </div>
            <div class="row">
              <p class="inputTitle editable">施工体制取得日時</p>
              <div class="rowRight">
                <input type="text" class="text large" name="constructionSystemAcquisitionDateTime"
                v-model="constructionSystemAcquisitionDateTime" readonly/>
              </div>
            </div>
            <div class="row">
              <p class="inputTitle editable">施工体制連携日時</p>
              <div class="rowRight">
                <input type="text" class="text large" name="constructionSystemLinkDateTime"
                v-model="constructionSystemLinkDateTime" readonly/>
              </div>
            </div>
            <div class="row">
              <p class="inputTitle editable"></p>
              <div class="rowRight" style="display: flex; gap: 10px;">
                <button class="edit" @click="getConstructionSystem" type="button"
                 style="min-width: 200px; border-radius:10px;">
                 施工体制取得
                </button>
                <button class="edit" @click="linkConstructionSystem" type="button"
                style="min-width: 200px; border-radius:10px;">
                  施工体制連携
                </button>
              </div>
            </div>
            <div class="row">
              <p class="inputTitle editable">施工体制取得状況</p>
              <div class="rowRight">
                <input type="text" class="text large" name="constructionSystemGetStatus"
                v-model="constructionSystemGetStatus" readonly/>
              </div>
            </div>
            <div class="row">
              <p class="inputTitle editable">施工体制連携状況</p>
              <div class="rowRight">
                <input type="text" class="text large" name="constructionSystemSyncStatus"
                v-model="constructionSystemSyncStatus" readonly/>
              </div>
            </div>
          </div>
          <div class="group">
            <div class="groupTitle" style="display: flex;">
              CCUS情報
            </div>
            <div v-for="inf in ccusInfs" v-bind:key="inf.id">
              <div class="inputTitle" style="display: flex;">
                {{dateFormat(inf.modified)}}
              </div>
              <textarea class="text large" rows="10" cols="60"
              style="height: 450px; width: 715px;" v-model="inf.value" readonly>
              </textarea>
            </div>
          </div>
        </form>
      </div>
    </div>
    <!-- 削除モーダル画面 -->
    <Modal size="delete" @close="closeModal()" v-if="ccusInfDeleteModal">
      <p class="modalTitle">削除しますか？</p>
      <div style="text-align:left; margin: 0px 30px 0px 30px; font-weight: bold;">
        <p>
          本当にCCUS情報を削除してよろしいですか？<br>
          一度削除したデータは復旧出来ませんので、ご了承下さい。<br>
          ※ep-Manager内での削除となり、CCUS側では削除されません。
        </p>
      </div>
      <button @click="ccusInfDelete()" class="modalYes">削除する</button>
      <button type="button" @click="closeModal()" class="modalNo" style="margin: 50px 0px 0px 30px;">キャンセル</button>
    </Modal>
  </div>
</template>

<script lang='ts'>
import { Component, Vue } from 'vue-property-decorator';
import { ValidationProvider, ValidationObserver } from 'vee-validate';
import { required } from 'vee-validate/dist/rules';
import moment from 'moment';
import Modal from './BaseModal.vue';
import ApiClient from '../services/ApiClient';
import { VueLoading } from 'vue-loading-template';
import common from '../services/common';
export default {
  title: '現場詳細',
  name: 'SiteDetail',
  components: {
    ValidationProvider,
    ValidationObserver,
    VueLoading,
    Modal,
  },
  props: {
    id: {
      type: String,
      default: '',
      required: true,
    },
    name: {
      type: String,
      default: '',
      required: true,
    },
  },
  // setup() {
  //   return {
  //   },
  // },
  data() {
    return {
      // 表示用データ格納用
      detail: {},
      // CCUS JSON情報
      ccusInf: '',
      ccusInfs: [
        {
          id: '',
          modified: '',
          value: '',
        },
      ],
      ccusInfDeleteModal: false,      // CCUS情報削除モーダル
      selectCcusInfId: '',     // 削除対象CCUS情報ID
      // 施工体制関連
      constructionSystemAcquisitionDateTime: '未取得',  // 施工体制取得日時
      constructionSystemLinkDateTime: '未連携',        // 施工体制連携日時
      constructionSystemGetStatus: '',                 // 施工体制取得の最新状況
      constructionSystemSyncStatus: '',               // 施工体制連携の最新状況
      syncStatusFailedMessage: '',                     // 施工体制取得・連携の最新状況取得失敗時のメッセージ
      // ローディング
      getLodingFlg: true,     // データ取得時ローディング用フラグ
      getErrorFlg: false,      // データ取得時エラーフラグ
      postLodingFlg: false,    // データ登録時ローディングフラグ
      postErrorFlg: false,     // データ登録時エラーフラグ
      // 入力チェック
      validationErrFlg: false, // 入力チェックエラーフラグ
      validationErrMsg: [],    // 入力チェックエラーメッセージ用配列
      errorMessage: '',
    };
  },
  // 初期処理
  async mounted() {
    try {
      // 現場一意情報取得API呼出
      await this.callGetSite();
      // 施工体制取得・連携の最新処理状況取得(運営管理者のみ)
      if (this.role === 'admin') {
        await this.getSyncConstructionStatus();
      }
      await new Promise((resolve) => setTimeout(resolve, 300));
    } catch (error) {
      // 既にエラーメッセージが入っている場合は上書きしない
      this.errorMessage =
        this.errorMessage ||
        (error && error.message) ||
        String(error);
      this.getErrorFlg = true;
    } finally {
      // ローディング非表示
      this.getLodingFlg = false;
    }
  },
  computed: {
    role() {
      return this.$store.getters.session.role;
    },
    isSidebarShow() {
      return this.$store.getters.session.isSidebarShow;
    },
  },
  watch: {
    role() {
      this.$nextTick(() => {
        // 必要であれば処理を書く 現状必要なロジックはない
      });
    },
    isSidebarShow() {
      this.$nextTick(() => {
        // 必要であれば処理を書く 現状必要なロジックはない
      });
    },
  },
  methods: {
    // 現場一意情報取得API呼出
    async callGetSite() {
      try {
        const restResourceService = new ApiClient();
        const result = await restResourceService.getSite(this.id);
        // エポックミリ秒をyyyy-mm-ddに変換
        result.startDate = common.dateFormatHyphen(result.startDate);
        result.endDate = common.dateFormatHyphen(result.endDate);
        result.createdAt = common.dateFormatHyphen(result.createdAt);
        result.updatedAt = common.dateFormatHyphen(result.updatedAt);

        // 表示用
        this.detail = result;

        // デバッグ: APIレスポンスの確認
        console.log('=== SiteDetail.vue - APIレスポンス確認:');
        console.log('  constructionSystemAcquisitionDateTime:', result.constructionSystemAcquisitionDateTime, '(型:', typeof result.constructionSystemAcquisitionDateTime, ')');
        console.log('  constructionSystemLinkDateTime:', result.constructionSystemLinkDateTime, '(型:', typeof result.constructionSystemLinkDateTime, ')');
        console.log('  全フィールド:', Object.keys(result));

        // 施工体制取得日時・連携日時の設定
        if (result.constructionSystemAcquisitionDateTime != null && result.constructionSystemAcquisitionDateTime !== undefined && result.constructionSystemAcquisitionDateTime !== '') {
          this.constructionSystemAcquisitionDateTime = common.dateTimeFormatLogJst(result.constructionSystemAcquisitionDateTime);
        } else {
          this.constructionSystemAcquisitionDateTime = '未取得';
        }
        if (result.constructionSystemLinkDateTime != null && result.constructionSystemLinkDateTime !== undefined && result.constructionSystemLinkDateTime !== '') {
          this.constructionSystemLinkDateTime = common.dateTimeFormatLogJst(result.constructionSystemLinkDateTime);
        } else {
          this.constructionSystemLinkDateTime = '未連携';
        }

        // 現場CCUS情報取得処理
        this.ccusInfs = await restResourceService.getCcusSite(this.id);

      } catch (error) {
      this.errorMessage = error.message;
      throw error;
      }
    },
    // CCUS情報追加処理
    async ccusInfAdd() {
      // ====================入力項目空白削除====================
      this.ccusInf = this.ccusInf.trim();
      // ====================入力チェック====================
      // 入力チェックメッセージ初期化
      this.validationErrMsg = [];
      const jsonCheckFlg = common.checkJson(this.ccusInf);
      // 郵便番号と住所の妥当性チェック(郵便番号,都道府県,市区町村)
      if (!jsonCheckFlg) {
        this.validationErrMsg.push('CCUS情報のJSONの構成が不正です');
      }
      if (this.validationErrMsg.length !== 0) {
        return;
      }
      try {
        const restResourceService = new ApiClient();
        const body = [{
          version: 1.0, // TODO: version取得方法
          ccusId: this.detail.ccusId,
          value: this.ccusInf,
          modified: '2022-08-15 14:36:25', // TODO: 連携日時の取得方法
        }];
        await restResourceService.postCcusSite(body);
        // 現場一意情報取得API呼出
        await this.callGetSite();
        this.ccusInf = null;
      } catch (error) {
      this.errorMessage = error.message;
      throw error;
      }
    },
    // CCUS情報削除処理
    async ccusInfDelete() {
      try {
        const restResourceService = new ApiClient();
        await restResourceService.deleteCcusSite(this.selectCcusInf);
      } catch (error) {
      this.errorMessage = error.message;
      throw error;
      } finally {
        this.closeModal();
      }
    },
    // CCUS情報削除モーダルを開く
    openModal(ccusInfId) {
      window.history.pushState(null, null, null);
      window.addEventListener('popstate', this.closeModal);
      this.selectCcusInf = ccusInfId;
      this.ccusInfDeleteModal = true;
    },
    // CCUS情報削除モーダルを閉じる
    closeModal() {
      window.removeEventListener('popstate', this.closeModal);
      this.ccusInfDeleteModal = false;
    },
    // 日付フォーマット適用
    dateFormat(date) {
       return common.dateTimeFormatLog(date);
    },
    // Googleマップを開く
    openGoogleMap() {
      window.open('http://maps.google.co.jp/maps?q=' + encodeURI(this.detail.address));
    },
    // 埋め込みGoogleマップAPI呼び出し
    embeddedGoogleMap() {
    },
    // 現場一覧画面に戻る
    siteList() {
      history.back();
    },
    // 施工体制取得処理
    async getConstructionSystem() {
      try {
        // ローディング表示
        this.postLodingFlg = true;
        // エラーフラグ初期化
        this.postErrorFlg = false;
        this.errorMessage = '';
        this.syncStatusFailedMessage = '';

        const restResourceService = new ApiClient();
        const result = await restResourceService.getConstructionSystem(
          this.detail.ccusId
        );

        // 成功した場合、レスポンスで返却される取得日時を反映
        if (result.acquisitionDateTime) {
          this.constructionSystemAcquisitionDateTime = common.dateTimeFormatLogJst(result.acquisitionDateTime);
        } else {
          this.constructionSystemAcquisitionDateTime = '未取得';
        }

        // 現場情報を再取得して最新の状態を反映
        await this.callGetSite();
      } catch (error) {
        this.errorMessage = error.message || '施工体制の取得に失敗しました。';
        this.postErrorFlg = true;
      } finally {
        this.postLodingFlg = false;
      }
    },
    // 施工体制連携処理
    async linkConstructionSystem() {
      try {
        // ローディング表示
        this.postLodingFlg = true;
        // エラーフラグ初期化
        this.postErrorFlg = false;
        this.errorMessage = '';
        this.syncStatusFailedMessage = '';

        const restResourceService = new ApiClient();
        const result = await restResourceService.linkConstructionSystem(
          this.detail.ccusId
        );

        // 成功した場合、レスポンスで返却される連携日時を反映
        if (result.linkDateTime) {
          this.constructionSystemLinkDateTime = common.dateTimeFormatLogJst(result.linkDateTime);
        } else {
          this.constructionSystemLinkDateTime = '未連携';
        }

        // 現場情報を再取得して最新の状態を反映
        await this.callGetSite();
      } catch (error) {
        this.errorMessage = error.message || '施工体制の連携に失敗しました。';
        this.postErrorFlg = true;
      } finally {
        this.postLodingFlg = false;
      }
    },
    // 施工体制取得/連携の最新状況取得
    async getSyncConstructionStatus() {
      try {
        const restResourceService = new ApiClient();
        const result = await restResourceService.getSyncConstructionStatus(
          this.id
        );
        // 成功した場合、レスポンスで返却される連携ステータスを反映
        this.syncStatusFailedMessage = '';
        this.constructionSystemGetStatus = result.process?.get?.statusName ?? '未取得';
        this.constructionSystemSyncStatus = result.process?.sync?.statusName ?? '未連携';
      } catch (error) {
        console.warn('getSyncConstructionStatus failed:', error);
        this.syncStatusFailedMessage =
          '施工体制取得/連携状況の取得に失敗しました。画面をリロードしてください。';
        this.constructionSystemGetStatus = '未取得';
        this.constructionSystemSyncStatus = '未連携';
      }
    },
  },
  // updated: function() {
  //   try {
  //     // 緯度経度取得API　Community Geocoder　https://geolonia.com/
  //     getLatLng(this.detail.fullAddress, (latlng) => {
  //       var mymap = L.map('mapid').setView([latlng.lat, latlng.lng], 16);
  //       var marker = L.marker([latlng.lat, latlng.lng]).addTo(mymap);
//         var marker = L.marker([latlng.lat, latlng.lng]).addTo(mymap);
// marker.bindPopup("<p>popup1</p><p>地図表示時に一緒に表示されます。</p>").openPopup();
  //       L.tileLayer('http://{s}.tile.osm.org/{z}/{x}/{y}.png', {
  //         maxZoom: 18,
  //         attribution: 'Map data &copy; <a href="http://openstreetmap.org">OpenStreetMap</a> contributors, ',
  //       }).addTo(mymap);
  //     });
  //   } catch (error) {
  //     this.errorMessage = error.message;
  //     throw error;
  //   }
  // },
};
</script>

<!-- Add 'scoped' attribute to limit CSS to this component only -->
<style lang="scss" scoped>
@import "../style/variables.scss";
.modalTitle {
  margin: 30px auto;
  font-weight: bold;
  font-size: $font-medium;
  color: $font_color;
}
.modalYes {
  background-color: $button-primary;
  color: $active_font_color;
  font-size: $font-medium;
  width: 200px;
  height: 50px;
  padding: 10px, 10px;
  margin-bottom: 20px;
  border-radius: 10px;
  border: none;
  cursor: pointer;
  outline: none;
  appearance: none;
  font-weight: bold;
}
.modalNo {
  background-color: $button-danger;
  color: $active_font_color;
  font-size: $font-medium;
  width: 200px;
  height: 50px;
  padding: 10px, 10px;
  border-radius: 10px;
  border: none;
  cursor: pointer;
  outline: none;
  appearance: none;
  font-weight: bold;
}
</style>
<style type="text/css">
#mapid { height: 325px; width: 550px}
</style>
